import {
  Card,
  CardActions,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "../../../../hooks/useTranslation";
import AcceptButton from "../../PendingRequestData/AcceptButton";
import CancelButton from "../../PendingRequestData/CancelButton";
import { useStyles } from "./PendingRequestStyles";

type PendingRequestProps = {
  pendingRequests: any;
};

const PendingRequest = ({ pendingRequests }: PendingRequestProps) => {
  const classes = useStyles();
  const { t, BundleKey } = useTranslation();

  const Item = ({ title, value }: { title: string; value: string }) => (
    <ListItem style={{ paddingBlock: 0 }}>
      <Typography variant="subtitle1">
        <span>{`${title}: `}</span>
        <b>{value}</b>
      </Typography>
    </ListItem>
  );
  return (
    <Card className={classes.root}>
      <List>
        <Item
          title={t(BundleKey.PENDINGREQUEST_GRID_HEAD_LOT)}
          value={pendingRequests.lotNumber}
        />
        <Item
          title={t(BundleKey.PENDINGREQUEST_GRID_HEAD_RESIDENT)}
          value={pendingRequests.hostName + " - " + pendingRequests.hostPhone}
        />
        <Item
          title={t(BundleKey.PENDINGREQUEST_GRID_HEAD_GUEST)}
          value={pendingRequests.guest}
        />
        <Item
          title={t(BundleKey.PENDINGREQUEST_GRID_HEAD_DATEOFPASS)}
          value={
            pendingRequests.beginDateOfPass +
            " - " +
            pendingRequests.beginTimeOfPass +
            " a " +
            pendingRequests.endTimeOfPass
          }
        />
        <Item
          title={t(BundleKey.PENDINGREQUEST_GRID_HEAD_COMMENTS)}
          value={pendingRequests.comments}
        />
      </List>
      <CardActions>
        <CancelButton rowData={pendingRequests} isMobile={true} />
        <AcceptButton rowData={pendingRequests} isMobile={true} />
      </CardActions>
    </Card>
  );
};

export default PendingRequest;
